/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { Product } from '@api';
import { connect } from 'react-redux';
import { GABuilder } from 'src/js/services/CommonAnalyticsService';
import { IshState, ProductCartState } from '../../services/IshState';
import { Actions, requestProduct } from '../actions/Actions';
import { BuyButton, BuyButtonProps } from '../components/buyButton/BuyButton';

export default connect<any, any, any, IshState>(mapStateToProps, mapDispatchToProps)(BuyButton);

function isAdded(items: ProductCartState, id: string) {
  const item = items.result.find(itemId => itemId === id);
  return !!item;
}

function mapDispatchToProps(dispatch) {
  return {
    addProduct: (product: Product) => {
      dispatch({
        type: Actions.ADD_PRODUCT_TO_CART,
        payload: product,
        meta: {
          analytics: GABuilder.addProductToCart(product),
        },
      });
    },
    requestProductById: (id: string) => {
      dispatch(requestProduct({ id }));
    }
  };
}

function mapStateToProps(state: IshState, ownProps: BuyButtonProps) {
  return {
    product: state.products.entities[ownProps.id] || {},
    isAdded: isAdded(state.cart.products, ownProps.id),
    checkoutPath: state.config.checkoutPath,
  };
}
